import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Box,
} from "@mui/material";
import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import { CustomButtonComponent } from "./cutomBtn.component";

export interface CustomDialogProps {
  open: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  onConfirm?: () => void;
  confirmLabel?: string;
  cancelLabel?: string;
  maxWidth?: "xs" | "sm" | "md" | "lg" | "xl";
  showActions?: boolean;
}

export const CustomDialogComponent: React.FC<CustomDialogProps> = ({
  open,
  onClose,
  title,
  children,
  onConfirm,
  confirmLabel = "Confirmer",
  cancelLabel = "Annuler",
  maxWidth = "sm",
  showActions = true,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={maxWidth}
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "14px",
          padding: "6px",
          backgroundColor: "#FFFDF7",
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          color: "#B4006E",
          fontWeight: "bold",
          fontSize: "18px",
          padding: "16px 20px 10px",
        }}
      >
        {title}
        <IconButton
          onClick={onClose}
          sx={{
            color: "#B4006E",
            "&:hover": {
              backgroundColor: "rgba(180, 0, 110, 0.1)",
            },
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent
        sx={{
          padding: "12px 20px",
        }}
      >
        {children}
      </DialogContent>

      {showActions && (
        <DialogActions
          sx={{
            padding: "12px 20px 16px",
            display: "flex",
            justifyContent: "center",
            gap: 1.5,
          }}
        >
          <Box
            onClick={onClose}
            sx={{
              color: "#B4006E",
              fontWeight: "bold",
              fontSize: "13px",
              cursor: "pointer",
              padding: "8px 24px",
              borderRadius: "20px",
              border: "2px solid #B4006E",
              "&:hover": {
                backgroundColor: "rgba(180, 0, 110, 0.1)",
              },
            }}
          >
            {cancelLabel}
          </Box>
          {onConfirm && (
            <CustomButtonComponent
              label={confirmLabel}
              onClick={onConfirm}
              sx={{
                width: "auto",
                padding: "8px 24px",
              }}
            />
          )}
        </DialogActions>
      )}
    </Dialog>
  );
};
